import metadata from '../slices/metadata';
import type { RootStateType, ThunkDispatchType } from '../index';
import { getSettableForOrder, getSettableForTenant } from '../../api-admin/metadata';
import { MetadataSettableType } from '../../types';

export function fetchSettableMetadataForOrder() {
    return async (dispatch: ThunkDispatchType) => {
        try {
            dispatch(metadata.actions.fetchForOrder());
            const data: MetadataSettableType = await getSettableForOrder();
            dispatch(metadata.actions.fetchedForOrder({ data }));
        } catch (e) {
            console.log('ERROR fetching metadata for order, set redux error state and handle in errorBoundary.', e);
            dispatch(metadata.actions.fetchedForOrder({
                data: {
                    vehicleTypes: [],
                    equipment: [],
                    sustainability: [],
                    licencesCertificates: []
                }
            }));
        }
    };
}

export function fetchSettableMetadataForTenant() {
    return async (dispatch: ThunkDispatchType) => {
        try {
            dispatch(metadata.actions.fetchForTenant());
            const data: MetadataSettableType = await getSettableForTenant();
            dispatch(metadata.actions.fetchedForTenant({ data }));
        } catch (e) {
            console.log('ERROR fetching metadata for tenant, set redux error state and handle in errorBoundary.', e);
            dispatch(metadata.actions.fetchedForTenant({
                data: {
                    vehicleTypes: [],
                    equipment: [],
                    sustainability: [],
                    licencesCertificates: []
                }
            }));
        }
    };
}

export const selectSettableMetadataForOrder = () => (state: RootStateType) => state.metadata.metadataOrder;
export const selectFetchingSettableMetadataForOrder = () => (state: RootStateType) => state.metadata.fetchingForOrder;
export const selectSettableMetadataForTenant = () => (state: RootStateType) => state.metadata.metadataTenant;
export const selectFetchingSettableMetadataForTenant = () => (state: RootStateType) => state.metadata.fetchingForTenant;
